import "vuetify/styles";
import "@mdi/font/css/materialdesignicons.css";
import { istThemeLight } from "@de/ist.style_components_v3";
import { type I18n, useI18n } from "vue-i18n";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import * as labsComponents from "vuetify/labs/components";
import { createVueI18nAdapter } from "vuetify/locale/adapters/vue-i18n";

import i18n from "./i18n";

export default createVuetify({
	components: {
		...components,
		...labsComponents,
	},
	directives,
	icons: {
		aliases,
		defaultSet: "mdi",
		sets: {
			mdi,
		},
	},
	locale: {
		// vuetify's adapter type wants the generic `I18n<any, {}, {}, string, false>` shape;
		// our `i18n` instance is concretely typed (message schema + "de"|"en" locale union),
		// which is stricter/safer for app code but not structurally assignable here.
		adapter: createVueI18nAdapter({
			// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- matches vuetify's own adapter param type
			i18n: i18n as unknown as I18n<any, {}, {}, string, false>,
			useI18n,
		}),
	},
	theme: istThemeLight,
});
